import clsx from 'clsx';
import { type ReactNode, useMemo } from 'react';

import * as styles from '../Calendar.sty.js';
import { Year } from '../components/Year.js';
import { useSelectYear } from '../hooks/useSelectYear.js';
import {
  NUMBER_OF_YEAR_ROWS,
  NUMBER_OF_YEARS_PER_ROW,
} from '../types/calendarConfiguration.js';

/**
 * SelectYearView component
 * Renders a grid of buttons for selecting the year.
 * @internal
 */
export const SelectYearView = () => {
  const { years } = useSelectYear();

  const yearsToShow = useMemo(
    (): ReactNode =>
      new Array(NUMBER_OF_YEAR_ROWS).fill(0).map((_, index) => (
        <tr
          key={`${years[index]}-row-${index}`}
          className={clsx([styles.row, styles.yearRow])}
        >
          {years
            .slice(
              index * NUMBER_OF_YEARS_PER_ROW,
              index * NUMBER_OF_YEARS_PER_ROW + NUMBER_OF_YEARS_PER_ROW,
            )
            .map((year) => (
              <Year date={year} key={year.toISOString()} />
            ))}
        </tr>
      )),
    [years],
  );

  return <tbody>{yearsToShow}</tbody>;
};

SelectYearView['displayName'] = 'SelectYearView';
